// Angular
import { Injectable } from '@angular/core';
// Sore
import { Action, Selector, State, StateContext } from '@ngxs/store';
// Actions
import { ClearErrorException, LogErrorException } from './action/error-track.action';
// Service
// Model
import { ErrorTrackModel, ExceptionError } from './model/error-track.model';
import { Logout } from '../auth/action/auth.action';
import { ERROR_STATUS, ObjectUtils } from '@cv-invision/core';

@State<ErrorTrackModel>({
	name: 'errorTrack',
	defaults: {
		exceptionError: []
	}
})
@Injectable()
export class ErrorTrackState {

	/**
	 * Returns Error Track state.
	 * @param state
	 * @constructor
	 */
	@Selector()
	static errorTrackState(state: ErrorTrackModel): ErrorTrackModel {
		return state;
	}

	/**
	 * Return any new error logged
	 * @param state
	 */
	@Selector()
	static exceptionErrorList(state: ErrorTrackModel): ExceptionError[] {
		return state.exceptionError;
	}

	/**
	 * Register a new exception
	 * @param ctx
	 * @param channelName
	 */
	@Action(LogErrorException)
	logErrorException(ctx: StateContext<ErrorTrackModel>, {newExceptionError}: LogErrorException): any {
		const state: ErrorTrackModel = ctx.getState();
		let errorsTrack: ExceptionError[] = Object.assign([], state.exceptionError);

		// New Error Status and timestamp
		newExceptionError.status = ERROR_STATUS.NEW;
		newExceptionError.timestamp = Date.now();
		// Save Error at the beginning
		errorsTrack.unshift(newExceptionError);

		if (errorsTrack.length > 10) {
			errorsTrack = errorsTrack.slice(0, -1);
		}

		ctx.patchState({
			...state,
			exceptionError: errorsTrack
		});
	}

	/**
	 * Clear all Errors so next time
	 * @param ctx
	 * @param errorTypeToClear
	 */
	@Action(ClearErrorException)
	clearErrorException(ctx: StateContext<ErrorTrackModel>, { errorTypeToClear }: ClearErrorException): any {
		const state: ErrorTrackModel = ctx.getState();
		const errorsTrack: ExceptionError[] = ObjectUtils.recursiveDeepCopy(state.exceptionError);

		errorsTrack.forEach((exceptionError: ExceptionError) => {
			if (errorTypeToClear.includes(exceptionError.errorType)) {
				exceptionError.status = ERROR_STATUS.OLD;
			}
		});

		ctx.patchState({
			...state,
			exceptionError: errorsTrack
		});
	}

	/**
	 * Clear out the Error Track
	 * @param ctx
	 */
	@Action(Logout)
	logout(ctx: StateContext<ErrorTrackModel>): void {
		ctx.setState({
			exceptionError: []
		});
	}
}
